import { pathKey } from './path';

/** Assets domain query segments */
export const AssetsQueryKeys = {
  search: {
    all: ['assets/search'] as const,
    list: (search: unknown) => ['assets/search', search] as const,
    post: (payload: unknown) => [{ path: 'assets/search', payload }] as const,
  },
  /** Legacy singular segment used in LinkAssets */
  searchLegacy: {
    list: (payload: unknown) => ['asset/search', payload] as const,
  },
  detail: (uid: string) => pathKey(`assets/${uid}`),
  detailSegment: (uid: string) => [`assets/${uid}`] as const,
  assetTypes: {
    all: ['asset-types'] as const,
    pathAll: () => pathKey('asset-types'),
    pathDetail: (uid: string) => pathKey(`asset-types/${uid}`),
    segmentDetail: (uid: string) => [`asset-types/${uid}`] as const,
  },
  filterValues: {
    all: ['asset-filter-values'] as const,
  },
};
